<template>
  <!-- Global notifications handler -->
  <div class="alertBox">
    <notification :notification="notification"
                  v-for="notification in reverseNotifications"
                  :key="notification.index"/>
  </div>
</template>

<style scoped>
.alertBox {
  width: 1110px;
  position: fixed;
  display: block;
  z-index: 9999;
  top: 20px;
  height:auto;
}

@media (width < 1200px) {
  .alertBox {width: 930px;}
}

@media (width < 992px) {
  .alertBox {width: 690px;}
}

@media (width < 768px) {
  .alertBox {width: 510px;}
}

@media (width < 572px) {
  .alertBox {max-width: 88vw; width:100%;}
}

</style>

<script>
  import { mapGetters } from 'vuex'
  import Notification from './Notification'

  export default {
    computed: {
      ...mapGetters([
        'reverseNotifications'
      ])
    },

    components: {
      Notification
    }
  }
</script>



// WEBPACK FOOTER //
// Notifications.vue?31353fe8